module.exports = __webpack_public_path__ + "static/media/7035_9010.f49611ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hullColors/7035_9010.jpg
// module id = 86
// module chunks = 0